export const RANKING_IMAGES = [
  'ribbons_top_numberOne_icon',
  'ribbons_top_numberTwo_icon',
  'ribbons_top_numberThree_icon',
  'ribbons_top_numberFour_icon',
  'ribbons_top_numberFive_icon',
  'ribbons_top_numberSix_icon',
  'ribbons_top_numberSeven_icon',
  'ribbons_top_numberEight_icon',
  'ribbons_top_numberNine_icon',
  'ribbons_top_numberTen_icon',
];
